// Sort jobs by various criteria
export const sortJobs = (jobs, sortBy = 'scheduled_date', sortOrder = 'asc') => {
  return [...jobs].sort((a, b) => {
    let aValue = a[sortBy];
    let bValue = b[sortBy];

    // Handle dates
    if (sortBy.includes('_date') || sortBy.includes('_at')) {
      aValue = aValue ? new Date(aValue) : new Date(0);
      bValue = bValue ? new Date(bValue) : new Date(0);
    }

    // Handle numbers
    if (sortBy === 'price' || sortBy.includes('duration')) {
      aValue = parseFloat(aValue) || 0;
      bValue = parseFloat(bValue) || 0;
    }

    // Handle strings
    if (typeof aValue === 'string') {
      aValue = aValue.toLowerCase();
      bValue = bValue.toLowerCase();
    }

    // Handle null/undefined values
    if (aValue == null && bValue == null) return 0;
    if (aValue == null) return sortOrder === 'desc' ? 1 : -1;
    if (bValue == null) return sortOrder === 'desc' ? -1 : 1;

    if (sortOrder === 'desc') {
      return aValue < bValue ? 1 : aValue > bValue ? -1 : 0;
    } else {
      return aValue > bValue ? 1 : aValue < bValue ? -1 : 0;
    }
  });
};

// Filter jobs by search term
export const filterJobs = (jobs, searchTerm) => {
  if (!searchTerm) return jobs;

  const search = searchTerm.toLowerCase();
  return jobs.filter(job =>
    job.category_name?.toLowerCase().includes(search) ||
    job.description?.toLowerCase().includes(search) ||
    job.customer_name?.toLowerCase().includes(search) ||
    job.technician_name?.toLowerCase().includes(search) ||
    job.service_type?.toLowerCase().includes(search) ||
    job.status?.toLowerCase().includes(search)
  );
};